import SEOHead      from "@/components/SEOHead";
import Navbar       from "@/components/Navbar";
import Hero         from "@/components/Hero";
import Showcase     from "@/components/Showcase";
import Services     from "@/components/Services";
import Testimonials from "@/components/Testimonials";
import Contact      from "@/components/Contact";
import Footer       from "@/components/Footer";

/* Two sections have gone since the first pass. StatsTicker was a marquee of
   claims wedged between the promise and the proof — the hero's own proof band
   replaced it. <Process /> stated the same ladder as <EngagementModel /> in
   near-identical words, so the ladder now lives in one place. <ICPRouter />
   folded into <Services />, which now carries all six internal links in half
   the prose — the routes matter for SEO, the paragraphs around them did not.

   <StickyCTA /> has gone too. It was the only mount of that component, it sat
   above the mobile menu and the video lightbox in the stacking order, and once
   the contact form had scrolled past it reappeared as a gold bar floating over
   the footer's gold band. The page already carries the same ask three times
   without it. */
const LandingPage = () => (
  <>
    <SEOHead
      title="Kyrosity AI | Global Performance Creative | Find the Ads Worth Scaling"
      description="Performance creative that cuts customer acquisition cost. Free sample, first cut in 48 hours, for growth teams across India, the US, and beyond."
      canonical="https://www.kyrosity.ai/"
    />
    <a className="skip-link" href="#main">Skip to content</a>
    <Navbar />
    <main id="main" data-testid="landing-page" className="min-h-screen bg-ground">
      {/* Proof before the pitch. Testimonials used to sit fourth, after two
          full screens of work and services; the strongest sentences on the
          site were the last thing a visitor read before the form. */}
      <Hero />
      <Showcase />
      <Testimonials />
      <Services />
      <Contact />
    </main>
    <Footer />
  </>
);

export default LandingPage;
